<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import QuotesModal from "@/components/Quotes/QuotesModal.vue";
import ComponentsKeys from "@/mixins/ComponentsKeys";
import _ from "lodash";
import VDataTableQuotesGrouped from "@/components/VDataTable/VDataTableQuotesGrouped.vue";

export default {
    name: "SessionQuotesGrouped",
    components: {
        VDataTableQuotesGrouped,
        QuotesModal,
        AjaxLoad,
    },
    mixins: [
        ComponentsKeys,
    ],
    data() {
        return {
            response: null,
            componentsKeys: {
                quotesModal: this.getRandomKey('quotesModal')
            },
        };
    },
    props: {
        idProject: {
            type: String,
        },
        idSessionEps: {
            type: Number,
        },
        idSession: {
            type: Number,
        },
    },
    computed: {
        quotes() {
            return this.response?.data || [];
        },
        permissions() {
            return this.response?.meta?.permissions || {};
        },
        filteredQuotes() {
            return this.idSessionEps !== undefined ? _.filter(this.quotes, {id_session_eps: this.idSessionEps}) : this.quotes;
        },
    },
    methods: {
        doShowModal(id, data = {}) {
            this.$refs.quotesModal.show(id, data)
                .then((result) => {
                    if (result !== false) {
                        this.$refs.ajax.load();
                    }
                })
                .finally(() => {
                    this.updateComponentKey('quotesModal');
                });
        },
        onDblClickRow(e, {item}) {
            this.doShowModal(item.id);
        },
        onClickAdd() {
            this.doShowModal(0, {id_session_eps: this.idSessionEps, id_sessions: this.idSession});
        },
    },
}
</script>

<template>
    <ajax-load
        ref="ajax"
        v-model="response"
        :active="idProject || false"
        :url="$apiUrl.getQuotesUrl({id_project: idProject})"
        :transform="response => response.data"
        v-slot="{resolved, active}"
    >
        <v-card>
            <v-card-title>Цитаты</v-card-title>

            <v-data-table-quotes-grouped
                :loading="!resolved && !!active"
                :items="filteredQuotes"
                :custom-permissions="permissions"
                @dblclick:row="onDblClickRow"
                @click:add="onClickAdd"
            ></v-data-table-quotes-grouped>

            <quotes-modal
                ref="quotesModal"
                :key="componentsKeys.quotesModal"
                :id-project="idProject"
            ></quotes-modal>
        </v-card>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>
